<template>
  <div class="plugins-directory">
    <h1 class="mb-4">Plugins</h1>

    <div v-if="!plugins || plugins.length === 0" class="alert alert-info">
      <strong>No plugins enabled.</strong>
      <p class="mb-0">Contact your administrator to enable plugins for this store.</p>
    </div>

    <div v-else class="row">
      <div v-for="plugin in plugins" :key="plugin.name" class="col-12 col-md-6 col-lg-4 mb-4">
        <div class="card h-100 plugin-card">
          <div class="card-body d-flex flex-column">
            <div class="d-flex align-items-center mb-3">
              <i class="bi fs-1 me-3 text-primary" :class="plugin.icon"></i>
              <div>
                <h5 class="card-title mb-0">{{ plugin.displayName }}</h5>
                <small class="text-muted">v{{ plugin.version }}</small>
              </div>
            </div>

            <p class="card-text flex-grow-1">{{ plugin.description }}</p>

            <router-link
              :to="`/store/${storeKey}${plugin.route}`"
              class="btn btn-primary mt-auto"
            >
              Open {{ plugin.displayName }}
              <i class="bi bi-arrow-right ms-2"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

const store = useStore()
const route = useRoute()

const storeKey = computed(() => route.params.storeKey)
const plugins = computed(() => store.state.eshop.eshop?.plugins || [])
</script>

<style scoped>
.plugin-card {
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.plugin-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.plugin-card .btn {
  width: 100%;
}
</style>
